class BookingGatherTab {
  constructor() {
    this.container = document.querySelector('.js-gather-tab');
    this.bookingButton = document.querySelector('.book-now__button');
    this.init();
  }

  init() {
    if (!this.container) {
      return;
    }

    this.container.dataset.brandVenuesRfp = 'false';

    document.querySelectorAll('[data-rfp]').forEach((link) => {
      link.addEventListener('click', () => {
        const { hotelId, additionalHotelId } = link.closest('.brand-venues__card').dataset;
        const actualHotelId = additionalHotelId ?? hotelId;
        const eventProperty = this.container.querySelector('.js-booking-event-property');
        if (eventProperty.querySelector(`[value="${actualHotelId}"]`) && actualHotelId) {
          eventProperty.value = actualHotelId;
        }

        this.container.dataset.brandVenuesRfp = 'true';
      });
    });

    this.bookingButton.addEventListener('click', () => {
      this.container.querySelector('.js-booking-event-property').value = '';
      this.container.dataset.brandVenuesRfp = 'false';
    });
  }
}

export default BookingGatherTab;
